import { createAction } from 'redux-starter-kit';
import { get } from '../../../utility/via-fetch';
import { requestStart, requestSucceded, requestFailed } from '../../domain/requests/RequestActions';
import { putTranslations } from '../../domain/appConfig/translationsActions';

/**
 * An action that signifies a request to load some basic application config data
 */
export const loadTranslations = createAction('LOAD_TRANSLATIONS');

/**
 * A action that retrieves an application config object from the server
 * @param {string} locale The unique identifier of teh current app language E.G es_MX
 */
export function requestLoadTranslations(locale) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(loadTranslations.toString()));
    dispatch(loadTranslations({ requestId }));
    try {
      const translations = await get(`/api/application-configurations/languages/${locale}`, undefined, { });
      const identifiedTranslations = { ...translations, translationLocale: locale };
      dispatch(putTranslations(identifiedTranslations));
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId)); // We failed.
    }
  };
}
